import styles from "./showcase.module.scss";
import { BlueTick } from "@/assets/icons";
import { formatNumberPrice } from "@/utils/numberFormat";
import { Button, message } from "antd";
import moment from "moment";
import { useState } from "react";
import { useHistory } from "react-router-dom";

interface IProps {
  collectionName: string;
  coverImage: string;
  id: string;
  startTime: string;
  totalMintedAmount: string;
}

const NftCard = ({
  collectionName,
  coverImage,
  startTime,
  totalMintedAmount,
  id,
}: IProps) => {
  const history = useHistory();
  const [hovering, setHovering] = useState(false);

  const handlePressMint = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (hovering) {
      e.stopPropagation();
    }

    if (!id) {
      message.error("Collection id is undefined");
      return;
    }

    history.push({
      pathname: `/launchpad/${id ?? ""}/detail`,
    });
  };

  return (
    <div
      className={styles.nft_card}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      onClick={handlePressMint}
    >
      <div className={styles.img_wrapper}>
        <img alt={id ?? ""} src={coverImage ?? ""} />
        <Button className={styles.mint_btn}>Mint now</Button>
      </div>
      <div className={styles.nft_info}>
        <div className={styles.nft_name}>
          <label>{collectionName}</label>
          <BlueTick />
        </div>
        <div className={styles.nft_stat}>
          {moment(startTime).isAfter(Date.now()) ? (
            <div className={styles.stat_item}>
              <label>Starts</label>
              <p>{moment(startTime).format("MM/DD")}</p>
            </div>
          ) : (
            <div className={styles.stat_item}>
              <label>Minting</label>
              <p>Now</p>
            </div>
          )}

          <div className={styles.stat_item}>
            <label>Minted</label>
            <p>{formatNumberPrice(totalMintedAmount)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NftCard;
